/* eslint-disable no-undef */
import axios from "axios";
import { print } from "graphql";
import gql from "graphql-tag";
import awsconfig from "../../awsconfig";
import getMaintenanceMode from "../../utilities";

interface SessionDetails {
  correlationId: string;
  brand: string;
  country: string;
  source: string;
  language: string;
}

interface Payload {
  username: string;
  loginAuthenticatorCode: string;
  sessionDetails: SessionDetails;
}

const gqlRequest = gql`
  mutation EnrollInPaperless($Request: EnrollInPaperlessRequest!) {
    enrollInPaperless(Request: $Request) {
      IsSuccess
      Errors {
        ErrorCode
        ErrorMessage
        ErrorStack
      }
    }
  }
`;

export const enrollInPaperless = async (payload: Payload) => {
  const { username, loginAuthenticatorCode, sessionDetails } = payload;

  try {
    const getMode = await getMaintenanceMode();
    if (getMode === true) {
      return {
        data: {
          inMaintenance: "Y",
        },
      };
    }

    const request = {
      UserName: username,
      LoginAuthenticatorCode: loginAuthenticatorCode,
      Brand: sessionDetails.brand,
      Country: sessionDetails.country,
      ParentFunctionName: "EnrollInPaperless",
      ProcessName: "Enroll In Paperless",
      SourceApp: sessionDetails.source,
      WidgetName: sessionDetails.source,
      CorrelationId: sessionDetails.correlationId,
      Source: sessionDetails.source,
    };

    const response = await axios({
      url: awsconfig.aws_appsync_graphqlEndpoint,
      method: "post",
      headers: {
        "x-api-key": process.env.REACT_APP_API_KEY,
      },
      data: {
        query: print(gqlRequest),
        variables: {
          Request: request,
        },
      },
    });

    if (response?.data?.data?.enrollInPaperless?.IsSuccess) {
      return {
        data: {
          isSuccess: true,
        },
      };
    }

    if (
      response?.data?.data?.enrollInPaperless?.Errors ||
      response?.data?.data === null
    ) {
      return {
        data: {
          isSuccess: false,
          errors:
            response?.data?.data?.enrollInPaperless?.Errors?.[0] ||
            response?.data?.errors,
        },
      };
    }

    return {
      data: {
        isSuccess: false,
        error: response?.data?.errors || response?.data || response,
      },
    };
  } catch (error) {
    return {
      error: error instanceof Error ? error.message : String(error),
    };
  }
};

export default enrollInPaperless;